import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VueMeta from 'vue-meta';

import App from './App.vue';
import store from './store';
import router from './router';

Vue.config.productionTip = false;
Vue.prototype.$authhostname = 'https://auth.yasnah.com/';
Vue.prototype.$apihostname = 'https://api.yasnah.com/';

import Toast from './plugins/ToastService';
import Lock from './plugins/LockService';
import Modal from './plugins/ModalService';

import truncate from './filters/truncate';

Vue.use(Toast);
Vue.use(Lock);
Vue.use(Modal);
Vue.use(Vuelidate);
Vue.use(VueMeta, {
  keyName: 'meta',
  attribute: 'data-vue-meta',
  refreshOnceOnNavigation: true
});

Vue.filter('truncate', truncate);

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
